// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-title[data-v-2a40a1e5] {\n  height: 50px;\n}\n.item-text1[data-v-2a40a1e5] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
